import { DeleteModal } from "_components/modals";
import { CustomTable } from "_components/table/CustomTable";
import { alertActions, preAlertActions } from "_store";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export { AlertsAndPreAlertsTable }

function AlertsAndPreAlertsTable () {

    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const preAlerts = useSelector(state => state.preAlerts?.list);
    const preAlert = useSelector(state => state.preAlerts?.item);

    useEffect(() => {
        if(!preAlerts){
            dispatch(preAlertActions.getAll())
        }
    }, [])

    useEffect(() => {
        if(preAlerts){
            const values = Object.entries(preAlerts).map(([key, value]) => {
                return { id: key, ...value };
            });
            setData(values);
            setFilteredData(values); 
        }
    }, [preAlerts]);

    /* Gestion de l'affichage de la modale */
    const [show, setShow] = useState(false);
    const [preAlertToDelete, setPreAlertToDelete] = useState(null);

    const handleShowDeleteModal = (preAlert) => {
        setPreAlertToDelete(preAlert);
        setShow(true);
    };

    const handleCloseDeleteModal = () => {
        setShow(false);
    };

    /* Suppression d'une pré-alerte après confirmation par l'utilisateur */
    async function handleDeletePreAlert(item) {
        try {
            const response = await dispatch(preAlertActions.delete(preAlertToDelete.id));

            if (response.meta.requestStatus === 'rejected') {
                const errorMessage = response.error?.message || 'La suppression de la pré alerte a échoué.';
                throw new Error(errorMessage);
            }  else {
                const message = `Suppression de la pré-alerte "${preAlertToDelete.name}" réalisé avec succès`
                dispatch(alertActions.success({ message, showAfterRedirect: true }));
                //Après suppression, actualisation du store pour que la nouvelle pré-alertedisparaisse du tableau
                dispatch(preAlertActions.getAll());
            }
        } catch (error) {
            dispatch(alertActions.error(error));
        }
        setShow(false);
    }

    /* Action de visualisation de pré-alerte*/
    function viewAction(item) {
        dispatch(preAlertActions.setPreAlert(item))
    }

    /* Edition d'une pré-alerte existant
    *  Affectation de la pré-alerte au store et redirection vers le formulaire d'édition */
    function editAction(item) {
        dispatch(preAlertActions.setPreAlert(item))
        navigate(`/alertes/edit/${item.id}`)
    }

    /** Duplication d'une pré-alerte 
     *  Toutes les données sont dupliquées sauf l'id et la date de création */
    async function duplicateAction(item) {
        try {
            const { creation_date, id, name, ...newPreAlert} = item;
            newPreAlert.name = `${name} - copie`;

            const response = await dispatch(preAlertActions.create(newPreAlert));
                
            // Vérification du statut de la réponse
            if (response.meta.requestStatus === 'rejected') {
                const errorMessage = response.error?.message || 'La duplication de la pré alerte a échoué.';
                throw new Error(errorMessage);
            }  else {
                const message = `Duplication de la pré-alerte "${item.name}" réalisé avec succès`
                dispatch(alertActions.success({ message, showAfterRedirect: true }));
                //Après ajout, actualisation du store pour que la nouvelle pré-alerte apparaisse dans le tableau
                dispatch(preAlertActions.getAll());
            }
        } catch (error) {
            dispatch(alertActions.error(error));
        }
    }

    /* Modification de l'objet reçu de l'api en tableau d'objets */
    useEffect(() => {
        if (preAlerts) {
            const values = Object.entries(preAlerts).map(([key, value]) => {
                // Créer une nouvelle copie de l'objet avec l'ID ajouté si absent
                if (!value.hasOwnProperty('id')) {
                    return { ...value, id: key };
                }
                return { ...value };
            });
            setData(values);
        }
    }, [preAlerts]);

    useEffect(() => {
        if(preAlert){
            dispatch(preAlertActions.clearPreAlert())        
        }
    }, [])

    const headers = [
        { label: 'Nom', key: 'name', type: 'string', canToggle: false, visible: true},
        { label: 'Description', key: 'description', type: 'string', canToggle: false, visible: true },
        { label: '', key: 'warning', type: 'action', icon: 'warningAmberOutlinedRed', icon2:'warningAmberOutlinedRed', canToggle: false, visible: true, title: 'Cette alerte renvoie une erreur'},
        { label: '', key: 'shared', type: 'action', icon: 'verifiedOutlinedBlue', icon2:'verifiedOutlinedGrey', canToggle: false, visible: true, title: 'Statut des emails (icone gris = emails non renseignés)' },
        { label: '', key: 'view', type: 'action', action: viewAction, icon: 'loupeOutlined', canToggle: false, visible: true, title: 'Voir le détail de la pré-alerte'},
        { label: '', key: 'edit', type: 'action', action: editAction, icon: 'editOutlined', canToggle: false, visible: true, title: 'Modifier la pré-alerte'},
        { label: '', key: 'duplicate', type: 'action', action: duplicateAction, icon: 'contentCopyOutlined', canToggle: false, visible: true, title: 'Dupliquer la pré-alerte'},        
        { label: '', key: 'delete', type: 'action', action: handleShowDeleteModal, icon: 'deleteForeverOutlined', canToggle: false, visible: true, title: 'Supprimer la pré-alerte'},
    ]      

    return (
        <>
            {data && (
                <div className="custom-table-container">
                    <div className={'flex justify-between items-center'}>
                        <div className="flex items-center">
                            <span className={'title-customtable'}>{filteredData.length}</span>
                            <span className={'small-title-customtable'}>
                                {`Alerte${filteredData.length > 1 ? 's' : ''} et pré-alerte${filteredData.length > 1 ? 's' : ''}`}</span>
                        </div>                        
                    </div>
                    <div className={"my-4 "}>
                        <CustomTable data={filteredData} headers={headers} maxHeight={'65vh'}/>
                    </div>
                </div>
                
            )}
            <DeleteModal
                show={show}
                handleClose={handleCloseDeleteModal}
                handleDelete={handleDeletePreAlert}
                entityName={`la pré-alerte "${preAlertToDelete?.name ?? ''}"`}
            />
        </>
    )
}